/*
 * Cart Attributes
 * Intercepts every checkout entry point, reads /cart.js, and writes
 * one order-level note_attribute before navigating to /checkout:
 *
 *   Order Collection   e.g. "Dragon Dallas, San Antonio"
 *
 * Collection data is read from localStorage (_charly_cols), keyed by
 * product_id and written by the product snippet Liquid templates.
 */
(function () {
  'use strict';

  // Capture phase fires before any onclick attribute on the element,
  // so we can preventDefault before window.location is set.
  document.addEventListener('click', function (e) {
    var el = e.target.closest(
      'a[href="/checkout"], ' +
      '.js-button-checkout, ' +
      '.button-checkout, ' +
      '.mini-cart-checkout, ' +
      '.checkout-button'
    );
    if (!el) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    setCartAttributesThenCheckout();
  }, true);

  function setCartAttributesThenCheckout() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var orderCollections = [];
        var colMap = {};

        try {
          colMap = JSON.parse(localStorage.getItem('_charly_cols') || '{}');
        } catch (e) {}

        items.forEach(function (item) {
          var cols = colMap[String(item.product_id)] || [];
          cols.forEach(function (c) {
            if (orderCollections.indexOf(c) === -1) orderCollections.push(c);
          });
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Order Collection': orderCollections.join(', '),
            },
          }),
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[cart-attributes] failed to set attributes:', err);
        window.location.href = '/checkout'; // never block checkout
      });
  }
})();
